import ReactDOM from "react-dom/client";
import "rc-slider/assets/index.css";
import "./styles/scss/index.scss";
import "./styles/css/index.css";
import "./styles/fonts/line-awesome-1.3.0/css/line-awesome.css";
import "./i18n/i18n";
import App from "./App";
import { PostHogProvider } from "@posthog/react";
// import reportWebVitals from "./reportWebVitals";

const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST;

if (process.env.NODE_ENV === "development") {
  if (!posthogKey) {
    // eslint-disable-next-line no-console
    console.warn(
      "[PostHog] Missing REACT_APP_POSTHOG_KEY. No events will be sent."
    );
  }
  if (!posthogHost) {
    // eslint-disable-next-line no-console
    console.warn(
      "[PostHog] Missing REACT_APP_POSTHOG_HOST. Defaulting to https://app.posthog.com (may be wrong for EU projects)."
    );
  }
}

const options = {
  api_host: posthogHost || "https://app.posthog.com",
  autocapture: true,
  // We capture pageviews on route changes (see PostHogPageView) to avoid missing SPA navigations.
  capture_pageview: false,
  loaded: (posthog: any) => {
    if (process.env.NODE_ENV === "development") {
      posthog.debug();
    }
  },
} as const;


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <PostHogProvider apiKey={posthogKey} options={options}>
    <App />
  </PostHogProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(()=>{});
